import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class LoggerService {
  private readonly logPath = '/logs-certiplate-ui-v3'; // Path for log API

  constructor(private apiService: ApiService) {}

  private getRequestContext() {
    return {
      browserUrl: window.location.href,
      userAgent: navigator.userAgent,
    };
  }

  private getAuthToken() {
    return localStorage.getItem('JwtToken'); // Assuming the token is stored in localStorage
  }

  private sendLog(level: string, message: string, metaData: any = null, error?: any) {
    const logData = {
        message: typeof message === 'string' ? message : JSON.stringify(message),
        level,
        timestamp: new Date().toISOString(),
        request: this.getRequestContext(),
        metaData: metaData,
        error: error
            ? {
                name: error?.name || '',
                message: error?.message || '',
                stack: error?.stack || '',
                file: this.extractErrorFile(error),
            }
            : {},
    };

    const authToken = this.getAuthToken();
    const headers = { Authorization: `Bearer ${authToken}` };

    this.apiService.post(this.logPath, logData).subscribe({
        next: () => console.log('UI Log successfully sent to Backend'),
        error: (err) => console.error('Failed to send UI log', err),
    });
}
  
  private extractErrorFile(error: Error): string {
    let errorFile = 'Unknown';
    if (error && error.stack) {
      const stackLines = error.stack.split('\n');
      for (const line of stackLines) {
        const match =
          line.match(/\((.*):\d+:\d+\)$/) || line.match(/at (.*):\d+:\d+$/);
        if (match) {
          errorFile = match[1]; // Extract the file path
          break;
        }
      }
    }
    return errorFile;
  }

  info(message: string, metaData?: any) {
    this.sendLog('info', message, metaData);
  }

  debug(message: string, metaData?: any) {
    this.sendLog('debug', message, metaData);
  }

  error(message: string, error?: any) {
    this.sendLog('error', message, null, error);
  }
}
